/* Collapsible blocks (footer columns on phone, product tabs, FAQ): height animates to the inner height. */
(function () {
  if (window.elCollapsibles) return;
  window.elCollapsibles = true;
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.collapsible-trigger');
    if (!trigger) return;
    const id = trigger.getAttribute('aria-controls');
    const content = id && document.getElementById(id);
    if (!content) return;
    e.preventDefault();
    const open = !trigger.classList.contains('is-open');
    const inner = content.querySelector('.collapsible-content__inner');
    const height = inner ? inner.offsetHeight : content.scrollHeight;
    trigger.classList.toggle('is-open', open);
    trigger.setAttribute('aria-expanded', open);
    if (open) {
      content.classList.add('is-open');
      content.style.height = height + 'px';
      setTimeout(() => { if (trigger.classList.contains('is-open')) content.style.height = 'auto'; }, 500);
    } else {
      content.style.height = height + 'px';
      requestAnimationFrame(() => requestAnimationFrame(() => { content.style.height = '0px'; content.classList.remove('is-open'); }));
    }
  });
})();
